import { render } from "./ChampionshipInfo.vue?vue&type=template&id=47bd4d07"
import script from "./ChampionshipInfo.vue?vue&type=script&lang=js"
export * from "./ChampionshipInfo.vue?vue&type=script&lang=js"

import "./ChampionshipInfo.vue?vue&type=style&index=0&id=47bd4d07&lang=css"

import exportComponent from "D:\\Abdullah\\Projects\\R-Sport\\System\\rsport_dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__